export class Cotizacion{
  
		public idCotizacion:number;
		public monto:number;
		public comentario:string;
		public idCliente:number;
		
}


// WEBPACK FOOTER //
// ./src/app/models/cotizacion.ts